module.exports = __webpack_public_path__ + "static/media/Arataki Itto.a5f775cc.png";